mutation deleteMarketingPlan($input: DeletePlanInput!) {
  deleteMarketingPlan(input: $input)
}
